import React, { memo } from 'react'
import { IconPosition } from '@at/design-system-elements'
import { useAfterSignInUrl } from '../../hooks/after-signin-url-hook'
import { StyledYourSavedSearchesButton } from '../../components/save-search/save-a-search/save-search-button.style'
import { IconArrowRight } from '@at/design-system-icons'
import { TypeFiesta } from '@at/design-system-foundation'
import { useUserState } from '@at/connected-signin'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { YourSavedSearchesModal } from '../../components/save-search/your-saved-searches/your-saved-searches-modal'

const YourSavedSearchesCTA = () => {
    const [userState] = useUserState()
    const { showSavedSearches, setShowSavedSearches } = useSearchViewState()
    const { savedSearchesAfterSignInUrl } = useAfterSignInUrl('SAVE_SEARCH')

    const savedSearchLoggedIn = () => setShowSavedSearches(true)

    const savedSearchLoggedOut = () => (window.location.href = savedSearchesAfterSignInUrl)

    return (
        <>
            <StyledYourSavedSearchesButton
                data-testid="your-saved-searches-button"
                displayType="tertiary"
                iconPosition={IconPosition.RIGHT}
                iconSrc={<IconArrowRight title="Your saved searches" viewBox="3 -3 24 24" />}
                onInteraction={() => (userState.userSignedIn ? savedSearchLoggedIn() : savedSearchLoggedOut())}
                text={
                    userState.userSignedIn ? (
                        <TypeFiesta as="span">Your saved searches</TypeFiesta>
                    ) : (
                        <TypeFiesta as="span">Sign in to see your saved searches</TypeFiesta>
                    )
                }
                type={'button'}
                attributes={{ 'aria-label': 'Your saved searches' }}
            />
            <YourSavedSearchesModal handleHideModal={() => setShowSavedSearches(false)} isShowing={showSavedSearches} />
        </>
    )
}

export const YourSavedSearches = memo(YourSavedSearchesCTA)
